import {GameAvalancheAddSymbolsState} from 'src/avalanche/states/GameAvalancheAddSymbolsState';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';

export class TopGameAvalancheAddSymbolsState extends GameAvalancheAddSymbolsState {

	protected startAddingNewSymbols(): void {
		super.startAddingNewSymbols();
	}

	protected onAddingNewFinished(): void {
		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
	}
}



// WEBPACK FOOTER //
// ./src/topreels/states/TopGameAvalancheAddSymbolsState.ts